import React from 'react';
import { Box, Typography, Chip, IconButton } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import TimelineIcon from '@material-ui/icons/Timeline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import LaunchIcon from '@material-ui/icons/Launch';
import { ChangeItem } from '../../types/deployment';
import { getChangeTypeColor } from '../../utils/status.tsx';
import { useDeploymentStyles } from '../../styles/deployment';

interface ChangesListProps {
  changes: ChangeItem[];
}

export const ChangesList = ({ changes }: ChangesListProps) => {
  const classes = useDeploymentStyles();

  return (
    <Box mb={2}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          <TimelineIcon
            style={{ verticalAlign: 'middle', marginRight: 8, fontSize: 20 }}
          />
          Pending Changes
        </Typography>
        {changes.length > 0 && (
          <Chip
            label={`${changes.length} pending`}
            size="small"
            color="primary"
            variant="outlined"
          />
        )}
      </Box>

      {changes.length > 0 ? (
        <Box>
          {changes.map((change, i) => (
            <Box key={i} className={classes.changeItem}>
              <Box flex={1}>
                <Typography variant="body2">
                  <a
                    href={change.link || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.changeLink}
                  >
                    {change.text}
                  </a>
                </Typography>
                <Box mt={0.5}>
                  {change.tags?.map(tag => (
                    <Chip
                      key={tag}
                      label={tag}
                      size="small"
                      style={{
                        marginRight: 4,
                        fontSize: '0.75rem',
                        height: 20,
                      }}
                    />
                  ))}
                  {change.type && (
                    <Chip
                      label={change.type}
                      size="small"
                      style={{
                        backgroundColor: alpha(
                          getChangeTypeColor(change.type),
                          0.1,
                        ),
                        color: getChangeTypeColor(change.type),
                        fontSize: '0.75rem',
                        height: 20,
                      }}
                    />
                  )}
                </Box>
              </Box>
              <IconButton size="small" href={change.link ?? '#'} target="_blank">
                <LaunchIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}
        </Box>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          p={2}
          style={{ backgroundColor: alpha('#4caf50', 0.1), borderRadius: 8 }}
        >
          <CheckCircleIcon style={{ color: '#4caf50', marginRight: 8 }} />
          <Typography
            variant="body2"
            style={{ color: '#4caf50', fontWeight: 500 }}
          >
            All up to date! No pending changes.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
